import { AvatarProps, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AvatarStyled = styled(Avatar)<AvatarProps>(() => ({
  '&.MuiAvatar-root': {
    fontWeight: 600,
    fontSize: '0.875rem',
    height: '35px',
    width: '35px',
    border: '2px solid #ffffff',
    background: 'linear-gradient(135deg, #333636, #111313)',
  },
}));
